function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 35,
  cy: 35,
  r: 35,
  fill: "#2E81F7",
  fillOpacity: 0.09
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "m25.139 26.738.299.07v2.743a1.111 1.111 0 0 0-.563.949c0 .393.217.72.521.926l-.732 2.918c-.082.323.1.656.358.656h1.957c.258 0 .44-.334.357-.614l-.732-2.958c.304-.206.521-.534.521-.928 0-.41-.234-.756-.563-.95v-2.466L29 27.67v2.83c0 3.316 2.684 6 6 6s5.958-2.684 5.958-6L41 27.67l3.855-.932c.856-.205.856-1.265 0-1.476l-8.924-2.157a4.14 4.14 0 0 0-1.858 0l-8.935 2.157c-.849.205-.849 1.271 0 1.476Zm14.698 10.925L35 42.5l-4.837-4.837c-3.279 1.045-5.663 4.087-5.663 7.71 0 .9.728 1.627 1.625 1.627h17.752c.896 0 1.623-.727 1.623-1.627 0-3.623-2.386-6.665-5.663-7.71Z",
  fill: "#2E81F7"
});

function SvgIcPenggunaTerdaftar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcPenggunaTerdaftar);
export default __webpack_public_path__ + "static/media/ic_pengguna_terdaftar.efef29bc.svg";
export { ForwardRef as ReactComponent };